import { api } from "@/lib/api";
import type { ApiTaskPriority } from "@/services/task.service";

export interface PublicProfile {
	id: string;
	full_name: string | null;
	avatar_url: string | null;
}

export interface PublicTask {
	id: string;
	title: string;
	status: string;
	priority: ApiTaskPriority;
	due_date: string | null;
	updated_at: string;
	project: { id: string; name: string };
	task_type: { name: string; color: string; icon: string } | null;
	sprint: { id: string; name: string } | null;
	assigned_to: PublicProfile | null;
	additional_assignees: PublicProfile[];
}

export interface PublicStage {
	key: string;
	name: string;
	color: string;
}

export interface PublicFilterOptions {
	projects: { id: string; name: string }[];
	stages: PublicStage[];
	sprints: { id: string; name: string; status: string }[];
	assignees: PublicProfile[];
}

export interface PublicTaskQuery {
	project_id?: string;
	sprint_id?: string;
	status?: string;
	priority?: string;
	assigned_to?: string;
	search?: string;
	page?: number;
	limit?: number;
}

export interface PublicTaskPage {
	data: PublicTask[];
	total: number;
	page: number;
	limit: number;
}

export async function listPublicTasks(
	params: PublicTaskQuery,
): Promise<PublicTaskPage> {
	const query = new URLSearchParams();
	for (const [k, v] of Object.entries(params)) {
		if (v !== undefined && v !== "") query.set(k, String(v));
	}
	const qs = query.toString();
	return api.get<PublicTaskPage>(
		`/public/tasks${qs ? `?${qs}` : ""}`,
	);
}

export async function getPublicFilterOptions(): Promise<PublicFilterOptions> {
	const res = await api.get<{ success: boolean; data: PublicFilterOptions }>(
		"/public/filters",
	);
	return res.data;
}
